import { AppUI } from '@seedlang/state';

const DesktopOnly = ({ children }) => {
  if (AppUI.layout.isMobile) {
    return null;
  }

  return children;
};

export default DesktopOnly;